import { render, staticRenderFns } from "./SidebarNavMenu.vue?vue&type=template&id=46a73fc6&scoped=true&"
import script from "./SidebarNavMenu.vue?vue&type=script&lang=js&"
export * from "./SidebarNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNavMenu.vue?vue&type=style&index=0&id=46a73fc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a73fc6",
  null
  
)

export default component.exports